export default "__VITE_ASSET__uURk_STD__"